import {ColonistMembershipProduct} from '../../../../../../../shared/store/ColonistMembershipProduct'
import {UIStoreState} from '../../../../../../shared/scripts/store/UIStoreState'
import {createDivIn, createParagraphIn} from '../../../../../../shared/scripts/ui_utils/DomUtils'
import {UICheckoutAjaxEndPoints} from '../../../../../../shared/scripts/ui_checkout/UICheckoutAjaxEndPoints'
import {UIMMobileWebviewCommunication} from '../../../../ui_mobile_communication/UIMMobileWebviewCommunication'
import {MobileWebviewCommunicationActions} from '@colonist/mobile'
import {ClientUserState} from '../../../../../../shared/scripts/ClientUserState'
import {UIStoreGiftOverlayController} from '../../../../../../shared/scripts/store/gift/UIStoreGiftOverlayController'
import {UIStoreMembershipProductView} from '../../../../../../shared/scripts/store/UIStoreMembershipProductView'
import {UIMDeviceHandler} from '../../../UIMDeviceHandler'
import {PaymentMethod} from '../../../../../../../shared/store/BaseColonistStoreProduct'

export class UIMStoreMembershipProductView extends UIStoreMembershipProductView {
    constructor(container: HTMLDivElement, storeState: UIStoreState, membershipProduct: ColonistMembershipProduct, giftOverlay: UIStoreGiftOverlayController, localizedPrice?: string) {
        super(container, storeState, membershipProduct, giftOverlay, localizedPrice)

        createDivIn(this.buttonsContainer, 'loading-spinner')
    }

    protected sendToCheckout() {
        if(!ClientUserState.userState?.isLoggedIn) return
        this.buttonsContainer.classList.add('loading')
        if(UIMDeviceHandler.shouldEnableNativePaymentsOnMobile() == true) {
            UIMMobileWebviewCommunication.sendPayloadToMobile(MobileWebviewCommunicationActions.PurchaseMembership, {subscriptionId: this.membershipProduct.mobileIAPSKUId, userId: ClientUserState.userState.id, offerToken: ''})

            setInterval(() => {
                this.buttonsContainer.classList.remove('loading')
            }, 5000)
            return
        }
        void UICheckoutAjaxEndPoints.executeStripeColonistProductPurchaseSession(this.membershipProduct.storeProductType, this.membershipProduct.type, this.membershipProduct.itemQuantity)
        UIMMobileWebviewCommunication.sendPayloadToMobile(MobileWebviewCommunicationActions.ShowTopBottomSafeArea, true)
    }

    protected manageSubscription() {
        const isStripePaymentMethod = ClientUserState.userState?.items.membershipPaymentMethod == PaymentMethod.Stripe
        if(UIMDeviceHandler.shouldEnableNativePaymentsOnMobile() == true && !isStripePaymentMethod) {
            UIMMobileWebviewCommunication.sendPayloadToMobile(MobileWebviewCommunicationActions.ShowManageSubscriptions, this.membershipProduct.mobileIAPSKUId)
            return
        }
        UIMMobileWebviewCommunication.sendPayloadToMobile(MobileWebviewCommunicationActions.ShowTopBottomSafeArea, true)
        super.manageSubscription()
    }

    protected override addBestValueHint() {
        if(!this.membershipProduct.bestValue) return

        this.productDiv.classList.add('store_page_membership_best_value_border')
        createParagraphIn(this.headerDiv, {key: 'strings:storePage.bestValue'}, 'store_page_membership_best_value_banner')
    }
}
